// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__bjOdQ","text":"classes_text__2q4XD","active":"classes_active__2Y0jR"};